module.exports = __webpack_public_path__ + "static/media/VISITAS_EDUCATIVAS.61922d63.pdf";